// Vite entry. React 19 concurrent root + i18n boot before App mounts so
// the first paint already speaks the right language (no FOUC of English
// flashing into Turkish for operator users with a tr-TR preference).

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@/styles/globals.css";
import { App } from "@/App";
import { initI18n } from "@/i18n";
import { bootstrapOperatorDevAuth } from "@/auth/dev-auth";

async function bootstrap(): Promise<void> {
  // DEV-ONLY, and BEFORE render: AuthProvider hydrates the stored user on
  // mount, so a user written after that point would not be seen and
  // RequireOperatorAuth would redirect to a Keycloak that isn't running.
  // No-op in a production build (tree-shaken).
  await bootstrapOperatorDevAuth();

  const i18n = await initI18n();

  // Sync <html lang> with the resolved locale so screen readers pronounce
  // content correctly (WCAG 2.2 Level A — 3.1.1 Language of Page).
  // Re-sync on every locale change.
  document.documentElement.lang = i18n.language;
  i18n.on("languageChanged", (lng) => {
    document.documentElement.lang = lng;
  });

  const container = document.getElementById("root");
  if (!container) {
    throw new Error("operator-console: #root element missing from index.html");
  }

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
